import { ApiClient } from "@eventsquare/uikit";

export const Api = ApiClient.create({
  apiKey: import.meta.env.VITE_API_KEY,
  environment: import.meta.env.VITE_APP_ENVIRONMENT,
});
